import { render, staticRenderFns } from "./Numbers.vue?vue&type=template&id=26d855d4&"
import script from "./Numbers.vue?vue&type=script&lang=ts&"
export * from "./Numbers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports